export default () => ({
  all: [],
  fuel: [],
  make_code: [],
  model_code: [],
  status_code: [],
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
  },
});
